
/**
 * @author Sascha Dobschal <s.dobschal@tdsoftware.de>
 * date 07/16/2018
 */

export default function() {
    return {
        user: {
            token: ""
        },
        content: {},
        userAmount: 0,
        cart: []
    };
}


// WEBPACK FOOTER //
// ./src/store/state.js